"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chronometerBuilder = () => ({ executeProcesses, callbacks, functionId, processor, }) => {
    try {
        let seconds = 0;
        let minutes = 0;
        let hours = 0;
        const addZero = (value) => (value.toString().length === 1 ? `0${value}` : `${value}`);
        const startChronometer = () => {
            if (seconds === 60) {
                seconds = 0;
                minutes += 1;
                if (minutes === 60) {
                    minutes = 0;
                    hours += 1;
                }
            }
            seconds += 1;
            const time = `${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}`;
            executeProcesses(functionId, callbacks.successProcess, time);
        };
        let crono;
        if (processor.root.arrayTimers.length === 0) {
            crono = setInterval(startChronometer, 1000);
            processor.root.registerTimer({ timer: crono });
        }
        else {
            processor.root.clearTimers();
        }
    }
    catch (e) {
        executeProcesses(undefined, callbacks.errorProcess);
    }
};
exports.default = chronometerBuilder;
